import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = null;

const clearError = () => null;
const hasError = (_, { payload }) => payload.message;

export default createReducer(initialState, {
  [actionTypes.FETCH_CONVERSATION]: clearError,
  [actionTypes.FETCH_MESSAGES]: clearError,
  [actionTypes.POST_MESSAGE]: clearError,

  [actionTypes.FETCH_CONVERSATION_FAILURE]: hasError,
  [actionTypes.FETCH_MESSAGES_FAILURE]: hasError,
  [actionTypes.POST_MESSAGE_FAILURE]: hasError,
});
